module.exports = __webpack_public_path__ + "img/Logo12.d5fd1035.svg";